import { api } from "../api";

export type HealthCheckResponse = {
    status: "UP" | "DOWN" | string;
};

const findBackendHealth = async (token?: string) => {
    return api.get<HealthCheckResponse>("/actuator/health", {
        headers: token
            ? {
                Authorization: `Bearer ${token}`,
            }
            : undefined,
    });
};

export default findBackendHealth;
